"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getScoreName = void 0;
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
const i18next_1 = __importDefault(require("i18next"));
const getOutcomeParameterValue_1 = require("./getOutcomeParameterValue");
// TODO Remove after PLAT-2815 release
const getScoreName = (probWithOutcome) => {
    if ((0, getOutcomeParameterValue_1.getOutcomeParameterValue)({
        eventProbability: probWithOutcome,
        parameterType: betweb_openapi_axios_1.ParameterType.HomeScore,
    }) === '-1' &&
        (0, getOutcomeParameterValue_1.getOutcomeParameterValue)({
            eventProbability: probWithOutcome,
            parameterType: betweb_openapi_axios_1.ParameterType.AwayScore,
        }) === '-1') {
        return i18next_1.default.t('anyOther');
    }
    return `${(0, getOutcomeParameterValue_1.getOutcomeParameterValue)({
        eventProbability: probWithOutcome,
        parameterType: betweb_openapi_axios_1.ParameterType.HomeScore,
    })}:${(0, getOutcomeParameterValue_1.getOutcomeParameterValue)({
        eventProbability: probWithOutcome,
        parameterType: betweb_openapi_axios_1.ParameterType.AwayScore,
    })}`;
};
exports.getScoreName = getScoreName;
//# sourceMappingURL=getScoreName.js.map